(function (global, factory) {
  const api = factory(global);

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!global || !global.document) return;

  function getSection(control) {
    return control && control.closest('.aoy-originals-collection');
  }

  function getLayout(control) {
    const section = getSection(control);
    return section && section.querySelector('.aoy-originals-collection__layout');
  }

  function observeLayout(layout) {
    if (!layout || layout.dataset.aoyDrawerObserved === 'true') return;
    layout.dataset.aoyDrawerObserved = 'true';
    new global.MutationObserver(function () {
      api.syncDrawer(layout, global.document);
    }).observe(layout, { attributes: true, attributeFilter: ['class'] });
    api.syncDrawer(layout, global.document);
  }

  function observeResults(section) {
    const container = section && section.querySelector('#ProductGridContainer');
    if (!container || container.dataset.aoyResultsObserved === 'true') return;
    container.dataset.aoyResultsObserved = 'true';
    new global.MutationObserver(function () {
      api.syncResultCount(section);
    }).observe(container, { childList: true, subtree: true });
    api.syncResultCount(section);
  }

  function syncStatusTabs(section) {
    api.syncStatusTabs(section, global.location);
  }

  function initializeSection(section) {
    if (!section) return;
    observeResults(section);
    syncStatusTabs(section);
  }

  function initializeSections(root) {
    if (!root) return;
    if (root.matches && root.matches('.aoy-originals-collection')) initializeSection(root);
    if (root.querySelectorAll) root.querySelectorAll('.aoy-originals-collection').forEach(initializeSection);
  }

  global.document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.aoy-originals-collection .toggle-filtering');
    if (!toggle) return;

    const layout = getLayout(toggle);
    const drawer = layout && layout.querySelector('.aoy-originals-collection__filters');
    if (drawer) drawer.inert = false;
  }, true);

  global.document.addEventListener('click', function (event) {
    const closeControl = event.target.closest(
      '[data-aoy-originals-filter-close], .aoy-originals-collection .facets__mobile-close'
    );
    if (closeControl) {
      event.preventDefault();
      api.requestClose(getLayout(closeControl), global.document, closeControl);
      return;
    }

    const toggle = event.target.closest('.aoy-originals-collection .toggle-filtering');
    if (toggle) {
      global.requestAnimationFrame(function () {
        api.syncDrawer(getLayout(toggle), global.document);
      });
    }
  });

  global.document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const openLayout = global.document.querySelector(
      '.aoy-originals-collection__layout.grid-archive__main-container--filters-shown, ' +
      '.aoy-originals-collection__layout.grid-archive__main-container-mobile--filters-shown'
    );
    if (openLayout) api.requestClose(openLayout, global.document);
  });

  global.document.querySelectorAll('.aoy-originals-collection__layout').forEach(observeLayout);
  initializeSections(global.document);
  global.addEventListener('popstate', function () {
    global.document.querySelectorAll('.aoy-originals-collection').forEach(syncStatusTabs);
  });
  global.addEventListener('pageshow', function () {
    initializeSections(global.document);
  });
  global.document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });
})(typeof window !== 'undefined' ? window : undefined, function () {
  function isOpen(layout) {
    return Boolean(layout) && (
      layout.classList.contains('grid-archive__main-container--filters-shown') ||
      layout.classList.contains('grid-archive__main-container-mobile--filters-shown')
    );
  }

  function releaseScrollLock(documentRef) {
    if (!documentRef || !documentRef.body) return;
    const anotherMobileFilter = documentRef.querySelector && documentRef.querySelector(
      '.grid-archive__main-container-mobile--filters-shown'
    );
    if (!anotherMobileFilter) documentRef.body.classList.remove('no-scroll--laptop-down');
  }

  function syncDrawer(layout, documentRef) {
    if (!layout || !documentRef) return false;

    const section = layout.closest('.aoy-originals-collection');
    const toggle = section && section.querySelector('.toggle-filtering');
    const drawer = section && section.querySelector('.aoy-originals-collection__filters');
    const drawerOpen = isOpen(layout);

    documentRef.body.classList.toggle('aoy-originals-filter-open', drawerOpen);
    if (!drawerOpen) releaseScrollLock(documentRef);
    if (toggle) toggle.setAttribute('aria-expanded', String(drawerOpen));
    if (drawer) {
      drawer.setAttribute('aria-hidden', String(!drawerOpen));
      drawer.inert = !drawerOpen;
    }
    return drawerOpen;
  }

  function closeDrawer(layout, documentRef) {
    if (!layout || !documentRef) return;
    const section = layout.closest('.aoy-originals-collection');
    const toggle = section && section.querySelector('.toggle-filtering');
    layout.classList.remove(
      'grid-archive__main-container--filters-shown',
      'grid-archive__main-container-mobile--filters-shown'
    );
    syncDrawer(layout, documentRef);
    if (toggle) toggle.focus();
  }

  function requestClose(layout, documentRef, sourceControl) {
    if (!layout || !documentRef) return;
    const mobileOpen = layout.classList.contains('grid-archive__main-container-mobile--filters-shown');
    const nativeClose = layout.querySelector && layout.querySelector('.facets__mobile-close');
    if (mobileOpen && nativeClose && nativeClose !== sourceControl) nativeClose.click();
    closeDrawer(layout, documentRef);
  }

  function syncResultCount(section) {
    if (!section || !section.querySelector) return null;
    const result = section.querySelector('[data-aoy-originals-result-count]');
    if (!result) return null;

    const count = Number(result.getAttribute('data-aoy-originals-result-count'));
    if (!Number.isFinite(count)) return null;

    const countNode = section.querySelector('[data-aoy-originals-count]');
    const labelNode = section.querySelector('[data-aoy-originals-count-label]');
    const viewButton = section.querySelector('[data-aoy-originals-view-count]');
    if (countNode) countNode.textContent = String(count);
    if (labelNode) labelNode.textContent = count === 1 ? 'work' : 'works';
    if (viewButton) viewButton.textContent = 'View ' + count;
    return count;
  }

  function syncStatusTabs(section, locationRef) {
    if (!section || !section.querySelectorAll || !locationRef) return 'all';

    const params = new URLSearchParams(locationRef.search || '');
    const availabilityParam = section.getAttribute('data-aoy-availability-param');
    const availableValue = section.getAttribute('data-aoy-availability-available-value');
    const collectedValue = section.getAttribute('data-aoy-availability-collected-value');
    const selectedValues = availabilityParam ? params.getAll(availabilityParam) : [];
    let currentView = 'all';
    if (selectedValues.length === 1 && selectedValues[0] === availableValue) currentView = 'available';
    if (selectedValues.length === 1 && selectedValues[0] === collectedValue) currentView = 'collected';

    section.querySelectorAll('[data-aoy-action="status-tab"]').forEach(function (tab) {
      if (tab.getAttribute('data-aoy-status-view') === currentView) {
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.removeAttribute('aria-current');
      }
    });
    return currentView;
  }

  return {
    closeDrawer: closeDrawer,
    releaseScrollLock: releaseScrollLock,
    requestClose: requestClose,
    syncDrawer: syncDrawer,
    syncResultCount: syncResultCount,
    syncStatusTabs: syncStatusTabs,
  };
});
